import { useEffect, useRef, useState } from 'react'
import '@/features/f0/styles/bodyFonts'
import { useReferenceStyles } from './useReferenceStyles'
import { ProtoButton } from '@/features/d0/states'
import api from '@/services/api'
import '../u6.css'

export interface AIDisclosureOverlayProps {
  onAccepted: () => void
}

// Mandatory disclosure of what ZUPA sends to Gemini; Escape does not dismiss it.
export default function AIDisclosureOverlay({ onAccepted }: AIDisclosureOverlayProps) {
  useReferenceStyles()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const titleRef = useRef<HTMLHeadingElement>(null)

  useEffect(() => {
    titleRef.current?.focus()
  }, [])

  const handleAccept = async () => {
    setLoading(true)
    setError(null)
    try {
      await api.acceptAIDisclosure()
      onAccepted()
    } catch {
      setError('Something went wrong. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div id="zupa-complete" className="zupa-app z-ov" role="dialog" aria-modal="true" aria-labelledby="ai-disclosure-title">
      <section className="s7-panel z-ov__card z-ov__card--wide">
        <h2 id="ai-disclosure-title" tabIndex={-1} ref={titleRef}>
          How ZUPA generates your content
        </h2>
        <div className="z-ov__text">
          <p>
            To generate social media posts for you, ZUPA sends the following information to
            Google&apos;s Gemini AI for processing:
          </p>
          <ul>
            <li>Your prompt or content idea</li>
            <li>Your company information (name, industry, description)</li>
            <li>Your brand voice and writing samples</li>
            <li>Your target audience and persona profiles</li>
            <li>Your service/product descriptions</li>
          </ul>
          <p>
            This data is processed per Google&apos;s API terms and is <strong>not used to train
            Google&apos;s AI models</strong>.
          </p>
        </div>
        {error && <p className="z-error" role="alert">{error}</p>}
        <div className="z-ov__actions">
          <ProtoButton className="z-primary" onClick={handleAccept} disabled={loading}>
            {loading ? 'Processing...' : 'I understand'}
          </ProtoButton>
        </div>
      </section>
    </div>
  )
}
